import React from 'react'
import { withApp } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import { Image } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import icon01 from './assets/noun_click_927323_000000 copy 2.svg'
import './ToggleFileModal.css'

class ToggleFileModal extends React.Component {


  render(){
    return (
      <div className="Toggle-file-modal">

        <a onClick={e => this.props.app.toggleModal(e, 'file-modal', this.props.component.component)}>
          <div className="Toggle-file-modal-image">
            <Image src={this.props.src} aspectRatio={this.props.imgRatio} style={{ width: `${this.props.imgWidth}`}}/>
          </div>
          <div className="Toggle-file-modal-icon">
            <Image src={icon01} aspectRatio={76}/>
          </div>
        </a>

      </div>
    )
  }
}

export default withApp(ToggleFileModal)
